import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`You can enable this feature from your client-side by setting `}<inlineCode parentName="p">{`captureLog: true`}</inlineCode>{` in our `}<a parentName="p" {...{
        "href": "/docs/session-replay/installation?tab=React%20Native#step-two-configure-replay-settings"
      }}>{`React Native SDK config`}</a>{`.`}</p>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`Note:`}</strong>{` Console log recording is only available for Android.`}</p>
    </blockquote>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`export const posthog = new PostHog(
  '<ph_project_api_key>',
  {
    // Enable session recording. Requires enabling in your project settings as well.
    // Default is false.
    enableSessionReplay: true,
    sessionReplayConfig: {
      // Capture logs automatically. Default is true.
      // Android only (Native Logcat only)
      captureLog: true,
      ...
    },
  },
);
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      